/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
12.14.22: Update on primary form; allows user to submit multiple
harvest records in a single submission
Mech harvest create: Handles the creation of new records
***********************************************************/
/* Libraries */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
/* Actions */
import { 
  acresPerHour, 
  density, 
  estimatedLbs, 
  acresCompleted, 
  percentComplete,
  validateMechHarvestForm 
} from '../../../harvest_utils'
import { 
  fetchFieldsByLoc, 
  fetchBlocksByField 
} from '../../../actions';
import { 
  selectField, 
  createMechHarvest,
  createMechHarvest2, 
  prepareMechHarvest,
  prepareMechHarvest2,
  addHarvestRecord,
  setMechHarvestToEdit,
  editHarvestRecord,
  deleteHarvestRecord 
} from '../../../actions/harvest_actions';
/* Components */
import MechanicalHarvestForm2 from './mechHarvest_form_2';
import MechHarvestModal2 from '../mechHarvest_modal_2';
import MechHarvestFormTable from "../mechHarvest_form_table";

class MechanicalHarvestCreate extends Component {
  constructor(props) {
    super(props)
    this.handleHarvestRecord = this.handleHarvestRecord.bind(this)
  }
  handleHarvestRecord(callback) {
    const harvest = validateMechHarvestForm({
      seasons: this.props.seasons,
      employees: this.props.employees,
      equipmentList: this.props.equipmentNo
    })
    if (Object.keys(harvest).length === 0) return
   
    const preparedAcres = acresCompleted(harvest.treesCovered, this.props.selectedField.treePerAcre)
   
    return callback({
      ...harvest,
      submitter: this.props.eid,
      estimatedLbs: estimatedLbs(harvest.estLbsPerContainer, harvest.containerCount),
      acresPerHour: acresPerHour(harvest.hours, acresCompleted(harvest.treesCovered, this.props.selectedField.treePerAcre)),
      density: density(estimatedLbs(harvest.estLbsPerContainer, harvest.containerCount), harvest.treesCovered),
      acresCompleted: acresCompleted(harvest.treesCovered, this.props.selectedField.treePerAcre),
      percentComplete: percentComplete(preparedAcres, this.props.selectedField.mechHarvest)
    })
  }
  render() {
    return (
      <div>
        <blockquote>
          <span className="flow-text">Create Mechanical Harvest</span>
        </blockquote>
        <hr />
        <div className="container-fluid card">
          <div className="row">
            <MechanicalHarvestForm2
              fields={this.props.fields} 
              blocks={this.props.blocks}
              selectedField={this.props.selectedField}
              submitter={this.props.eid} 
              equipmentNo={this.props.equipmentNo} 
              employees={this.props.employees}
              toEdit={this.props.toEdit}
              fetchFieldsByLoc={this.props.fetchFieldsByLoc} 
              fetchBlocksByField={this.props.fetchBlocksByField}
              selectField={this.props.selectField}
              addHarvestRecord={() => this.handleHarvestRecord(this.props.addHarvestRecord)}
              editHarvestRecord={() => this.handleHarvestRecord(this.props.editHarvestRecord)}
            />
          </div>
          {
            this.props.harvestRecords.length > 0 ? 
            <div className="row">
              <MechHarvestFormTable 
                harvest={this.props.harvestRecords}
                employees={this.props.employees}
                editHarvest={(h) => this.props.setMechHarvestToEdit(h)}
                deleteHarvest={this.props.deleteHarvestRecord}
              />
            </div>
            : null
          }
          
          
        </div>
        <div className="row harvest-form-card">
          <MechHarvestModal2 
            id={'mechHarvest-modal'} 
            harvest={this.props.harvestRecords}
            previousHarvest={this.props.previousHarvest} 
            fields={this.props.fields}
            employees={this.props.employees} 
            onClick={() => this.props.createMechHarvest2({ harvest: this.props.harvestRecords })} 
          />
          <button data-target="mechHarvest-modal"
            className="btn waves-light waves-effect"
            onClick={() => 
              this.props.prepareMechHarvest2({
                harvest: this.props.harvestRecords, 
                fields: this.props.fields, 
                employees: this.props.employees, 
                type: 'create'   
              })
            }>
            Prepare
          </button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    blocks: state.harvest.blocks,
    eid: state.auth.user.guid,
    employees: state.harvest.employees.displaying,
    equipmentNo: state.harvest.equipmentNo,
    fields: state.harvest.fields,
    harvest: state.harvest.create.harvest,
    harvestRecords: state.harvest.create.harvestRecords,
    previousHarvest: state.harvest.create.previousHarvest,
    seasons: state.harvest.seasons,
    selectedField: state.harvest.create.selectedField,
    toEdit: state.harvest.create.toEdit
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addHarvestRecord,
    createMechHarvest,
    createMechHarvest2,
    deleteHarvestRecord,
    editHarvestRecord,
    fetchFieldsByLoc,
    fetchBlocksByField,
    prepareMechHarvest,
    prepareMechHarvest2,
    selectField,
    setMechHarvestToEdit
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MechanicalHarvestCreate);




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/create/mechHarvest_create.jsx